export default {
  logoutSuccess: 'Successfully logout.',
  logout: 'Logging out. . .',
  forgotPasswordSuccess: 'Please follow the instructions in the email to reset your password',
  forgotPasswordError: 'We cannot find an active account for the provided email. Please contact your System Administrator.',
  forgotPasswordForm: 'Forgot Password',
  forgotPasswordFormError: 'Error',
  forgotPasswordFormSuccess: 'Password Reset Email Sent'
};